/**
 * A Modal preset for one decision: an xs modal with the question as its
 * title, a short body, Cancel (secondary) and the confirm action (primary).
 * `danger` turns the confirm button Coral and the dialog into an alertdialog,
 * for an action that can't be undone. `loading` keeps it open and busy while
 * the confirm request runs.
 */
import type { ReactNode } from 'react'
import { Modal } from './Modal'

export interface ConfirmDialogProps {
  open: boolean
  title: ReactNode
  body: ReactNode
  confirmLabel: string
  cancelLabel?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({ open, title, body, confirmLabel, cancelLabel = 'Cancel', danger, loading, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      size="xs"
      title={title}
      danger={danger}
      onClose={onCancel}
      secondaryAction={{ label: cancelLabel, onClick: onCancel, disabled: loading }}
      primaryAction={{ label: confirmLabel, onClick: onConfirm, loading }}
    >
      <div className="text-body text-text-secondary">{body}</div>
    </Modal>
  )
}

export default ConfirmDialog
